import { Pipe, PipeTransform } from '@angular/core';
import { CarRentalGender } from '@pulpo/pulpo-models';

@Pipe({
  name: 'CarRentalCategoryGender',
  standalone: true,
})
export class CarRentalCategoryGenderPipe implements PipeTransform {
  transform(value: string | CarRentalGender): string {
    switch (value) {
      case 'CITY_CAR':
      case CarRentalGender.CITY_CAR:
        return 'Citadine';
      case 'COMPACT':
      case CarRentalGender.COMPACT:
        return 'Compacte';
      case 'SPACIOUS':
      case CarRentalGender.SPACIOUS:
        return 'Spacieuse';
      case 'NONE':
      case CarRentalGender.NONE:
        return 'Sans Préférence';
      default:
        return 'Inconnu';
    }
  }
}
